import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "src/i18n";
import "src/themes/global.scss";
import "src/utils/vconsole";

import LandingPage from "src/pages/Landing";
import ResgisterPage from "src/pages/Resgister";
import LoginPage from "src/pages/Login";
import ForgotPasswordPage from "src/pages/ForgotPassword";
import AdminListPage from "src/pages/AdminList";
import AdminDetailPage from "src/pages/AdminDetail";

function App() {
  return (
    <Router basename="/">
      <React.StrictMode>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<ResgisterPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/admin-list" element={<AdminListPage />} />
          <Route path="/admin-detail" element={<AdminDetailPage />} />
        </Routes>
      </React.StrictMode>
    </Router>
  );
}

export default App;
